import request from '@/utils/request'
export function login(data) {
  return request({
    url: '/alp/auth/login',
    data
  })
}

export function getInfo(token) {
  return request({
    url: '/user/info',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: '/alp/auth/logout'
  })
}

export function captcha() {
  return request({
    url: '/alp/captcha',
    method: 'get'
  })
}

/* 	个人设置 */
export function personal(data) {
  return request({
    url: 'alp/admin_user/personal',
    data
  })
}

/** 消息中心 */
export function getMessageList(data) {
  return request({
    url: 'alp/message/list',
    data
  })
}

/** 返回消息类型 */
export function getType(data) {
  return request({
    url: '/alp/message/get_type',
    data
  })
}

/** 未读消息 */
export function unread(data) {
  return request({
    url: 'alp/message/unread',
    data
  })
}

/** 更新为已读 */
export function read(data) {
  return request({
    url: 'alp/message/detail',
    data
  })
}

/** 全标已读 */
export function allRead(data) {
  return request({
    url: 'alp/message/all_read',
    data
  })
}

/** 获取铃声状态 */
export function getRing(data) {
  return request({
    url: 'alp/message/ring_status',
    data
  })
}

/** 设置铃声状态 */
export function setRing(data) {
  return request({
    url: 'alp/message/turn_ring',
    data
  })
}

/** 获取可默认页面列表 */
export function getPageOptions(data) {
  return request({
    url: '/alp/module/fuzzy_query',
    data
  })
}

